const config = require('../config').default

const props = {
  currentEnvironment: config.env,
  api_domain: config.internalHost,
  api_key: ''
}

const post = (path, parameters = {}, options) => {
  return request(path, parameters, 'post', options);
}

const get = (path, parameters = {}, options) => {
  return request(path, parameters, 'get', options);
}

const put = (path, parameters = {}, options) => {
  return request(path, parameters, 'put', options);
}

const patch = (path, parameters = {}, options) => {
  return request(path, parameters, 'patch', options);
}

const remove = (path, parameters = {}, options) => {
  return request(path, parameters, 'delete', options);
}

const request = (path, parameters, type = 'get', options, settings = props) => {
  if (parameters.version) {
    settings.version_id = parameters.version;
    delete parameters.version;
  }

  let extraQueryParams = getQueryParams(options != null ? options.queryParams : null);

  let requestUrl = `${settings.api_domain}/${path}?api_key=${settings.api_key}${extraQueryParams}`;
  
  let requestOptions = {
    method: type.toUpperCase()
  };
  // GET method for fetch throws an error if it contains a body parameter
  if (requestOptions.method !== 'GET' && Object.keys(parameters).length > 0)
    requestOptions.body = JSON.stringify(parameters)
  
  if (Object.keys(parameters).length > 0)
    requestOptions.headers = {
      'Content-Type': 'application/json'
    };

  return fetch(requestUrl, requestOptions);
}

const getQueryParams = (queryParams) => {
  if (!queryParams) return '';

  let key, params, value;
  params = [];
  
  for (key in queryParams) {
    value = queryParams[key];
    params.push(key + '=' + value);
  }

  if (!params.length) return '';
  return '&' + (params.join('&'));
}

module.exports = {
  post,
  get,
  put,
  patch,
  remove,
  request
}